import React, { Component } from "react";

class RichText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      boldActive: false,
      italicActive: false,
      underlineActive: false,
      content: this.props.content,
    };
    this.editorRef = React.createRef();
    this.savedRange = null;
  }

  componentDidUpdate(prevProps) {
    if (this.props.content !== prevProps.content) {
      this.setState({ content: this.props.content });
    }
  }

  saveSelection = () => {
    const sel = window.getSelection();
    if (sel.rangeCount > 0) {
      this.savedRange = sel.getRangeAt(0);
    }
  };

  restoreSelection = () => {
    const sel = window.getSelection();
    if (this.savedRange) {
      sel.removeAllRanges();
      sel.addRange(this.savedRange);
    }
  };

  handleFormat = (command, value = null) => {
    if (!this.props.disabled) {
      this.saveSelection();
      this.restoreSelection();
      document.execCommand(command, false, value);
      this.updateActiveStates();
      this.editorRef.current.focus(); // Refocus the editor to keep the selection
    }
  };

  updateActiveStates = () => {
    this.setState({
      boldActive: document.queryCommandState("bold"),
      italicActive: document.queryCommandState("italic"),
      underlineActive: document.queryCommandState("underline"),
    });
  };

  handleDescriptionChange = (event) => {
    const content = event.target.innerHTML;
    this.setState({ content }, () => {
      this.props.onContentChange(this.state.content); // Notify parent about content change
    });
  };

  toggleNumberedList = () => {
    if (!this.props.disabled) {
      this.handleFormat("insertOrderedList");
    }
  };

  toggleBulletList = () => {
    if (!this.props.disabled) {
      this.handleFormat("insertUnorderedList");
    }
  };

  handleHeaderChange = (event) => {
    const headerValue = event.target.value;
    const command = "formatBlock";
    const value = headerValue === "Normal" ? "p" : headerValue;
    this.handleFormat(command, value);
  };

  handleFontChange = (event) => {
    const fontValue = event.target.value;
    this.handleFormat("fontName", fontValue);
  };

  render() {
    const { boldActive, italicActive, underlineActive, content } = this.state;
    const { disabled } = this.props;

    const toolbarStyle = {
      border: "1px solid #ccc",
      padding: "10px",
      backgroundColor: "#f9f9f9",
      display: "flex",
      flexWrap: "wrap", //
      justifyContent: "space-between",
    };

    const buttonStyle = {
      background: "none",
      border: "none",
      cursor: "pointer",
      padding: "5px 10px",
      fontSize: "16px",
    };

    const editorStyle = {
      border: "1px solid #ccc",
      minHeight: "150px",
      maxHeight: "300px",
      overflow: "auto",
      padding: "10px",
      borderRadius: "4px",
    };

    return (
      <div>
        <div style={toolbarStyle}>
          <button
            type="button"
            style={{
              ...buttonStyle,
              color: boldActive ? "blue" : "black",
            }}
            onMouseDown={(e) => {
              e.preventDefault();
              this.handleFormat("bold");
            }}
            disabled={disabled}
          >
            <b>B</b>
          </button>
          <button
            type="button"
            style={{
              ...buttonStyle,
              color: italicActive ? "blue" : "black",
            }}
            onMouseDown={(e) => {
              e.preventDefault();
              this.handleFormat("italic");
            }}
            disabled={disabled}
          >
            <i>I</i>
          </button>
          <button
            type="button"
            style={{
              ...buttonStyle,
              color: underlineActive ? "blue" : "black",
            }}
            onMouseDown={(e) => {
              e.preventDefault();
              this.handleFormat("underline");
            }}
            disabled={disabled}
          >
            <u>U</u>
          </button>

          <button
            type="button"
            style={buttonStyle}
            onMouseDown={(e) => {
              e.preventDefault();
              this.toggleNumberedList();
            }}
            disabled={disabled}
          >
            <img
              src={"/numlist.png"}
              alt="num list"
              width="20px"
              height="20px"
            />
          </button>

          <button
            type="button"
            style={buttonStyle}
            onMouseDown={(e) => {
              e.preventDefault();
              this.toggleBulletList();
            }}
            disabled={disabled}
          >
            <img
              src={"/bulletlist.png"}
              alt="bullet list"
              width="20px"
              height="20px"
            />
          </button>

          <select
            className="p-1 border rounded"
            onChange={this.handleHeaderChange}
            defaultValue="p"
            disabled={disabled}
          >
            <option value="h1" className="option-heading h1">
              Heading 1
            </option>
            <option value="h2" className="option-heading h2">
              Heading 2
            </option>
            <option value="h3" className="option-heading h3">
              Heading 3
            </option>
            <option value="h4" className="option-heading h4">
              Heading 4
            </option>
            <option value="h5" className="option-heading h5">
              Heading 5
            </option>
            <option value="p" className="option-heading p">
              Normal
            </option>
          </select>
          <select
            className="p-1 border rounded"
            onChange={this.handleFontChange}
            disabled={disabled}
          >
            <option value="Arial">Sans Serif</option>
            <option value="Times New Roman">Serif</option>
            <option value="Courier New">Monospace</option>
          </select>
        </div>
        <div
          ref={this.editorRef}
          className="editor"
          contentEditable={!disabled}
          placeholder="Write Text"
          onBlur={this.handleDescriptionChange}
          onMouseUp={this.saveSelection}
          onKeyUp={this.updateActiveStates}
          onClick={this.updateActiveStates}
          style={editorStyle}
          dangerouslySetInnerHTML={{ __html: content }} // Render HTML content
        />
      </div>
    );
  }
}

export default RichText;
